<template>
  <el-cascader
    v-bind="$attrs"
    v-model="innerValue"
    filterable
    clearable
    :placeholder="placeholder"
    :props="config"
    :options="options"
    v-on="$listeners"
    v-no-space
  >
    <slot></slot>
    <template #[slotName] v-for="(slot, slotName) in $slots">
      <slot :name="slotName"></slot>
    </template>
  </el-cascader>
</template>

<script>
  import { getRegionTree } from '@/api/common'
  export default {
    name: 'YdCitySelect', // 地级归属
    props: {
      value: {
        type: [String, Number, Array],
        required: true
      },
      placeholder: {
        type: String,
        default: '请选择'
      },
      /**
       * 默认，单选模式，选择末级节点
       * 1 单选模式，可选任意节点
       * 2 多选模式，勾选父节点真正选中的都是叶子节点
       * 3 多选模式，可选任意节点
       *  */
      mode: {
        type: [Number, String],
        default: () => -1
      },
      props: {
        type: Object,
        default: () => {}
      },
      /**
       * 自定义请求接口，默认是原接口
       */
      customHttp: {
        type: Function,
        default: getRegionTree
      },
      /**
       * 字段格式话函数，默认返回false，代表未传格式化函数
       */
      fieldFormat: {
        type: Function,
        default: (data) => data
      }
    },
    data() {
      return {
        innerValue: '',
        options: []
      }
    },
    computed: {
      config() {
        const basicConfig = {
          expandTrigger: 'hover',
          label: 'areaName',
          value: 'id',
          children: 'childAreaManage'
        }
        if (parseInt(this.mode) === 1) {
          return { ...basicConfig, checkStrictly: true }
        }
        if (parseInt(this.mode) === 2) {
          return { ...basicConfig, multiple: true }
        }
        if (parseInt(this.mode) === 3) {
          return { ...basicConfig, multiple: true, checkStrictly: true }
        }
        return { ...basicConfig, ...this.props }
      }
    },
    watch: {
      innerValue: {
        handler(newVal, oldVal) {
          if (newVal === oldVal) {
            return
          }
          if (parseInt(this.mode) === 1 && this.options && this.options.length > 0) {
            const relVal = newVal && newVal.length ? newVal[newVal.length - 1] : ''
            if (relVal === this.value) {
              return
            }
            this.$emit('input', relVal)
            return
          }
          this.$emit('input', newVal)
        }
      },
      value: {
        handler(newVal) {
          if (newVal === this.innerValue) {
            return
          }
          if (
            Array.isArray(newVal) &&
            Array.isArray(this.innerValue) &&
            newVal.join(',') === this.innerValue.join(',')
          ) {
            return
          }
          if (parseInt(this.mode) === 1 && this.options && this.options.length > 0) {
            const relVal = this.findParentsId(this.options, newVal) || []
            const reaVal = relVal.reverse()
            if (Array.isArray(this.innerValue) && reaVal.join(',') === this.innerValue.join(',')) {
              return
            }
            this.innerValue = reaVal
            return
          }
          this.innerValue = newVal
        },
        immediate: true
      }
    },
    created() {
      this.getList()
    },
    methods: {
      async getList() {
        const { code, data } = await this.customHttp()
        if (code !== 0 || !Array.isArray(data)) {
          return
        }
        const temp = this.fieldFormat(data)
        this.options = this.filterChildNodes(temp)
        // 此判断用于解决，value获取到值后，options还没有值，组件没有正确设置值的问题
        if (this.value && parseInt(this.mode) === 1) {
          const relVal = this.findParentsId(this.options, this.value) || []
          const reaVal = relVal.reverse()
          this.innerValue = reaVal
        }
        // 多选时id回显
        if (this.value && parseInt(this.mode) === 2) {
          const relVal = this.findParenstsIds(this.options, this.value) || []
          console.log('reval', relVal)
          this.innerValue = relVal
        }
      },
      filterChildNodes(dataList) {
        return dataList.map((item) => {
          if (item.childAreaManage && item.childAreaManage.length > 0) {
            item.childAreaManage = this.filterChildNodes(item.childAreaManage)
          } else {
            delete item.childAreaManage
          }
          return item
        })
      },
      // 根据子id找父id,返回值不包含查找的id
      findParentsId(dataList, id) {
        if (dataList.length === 0) {
          return
        }
        for (let i = 0; i < dataList.length; i++) {
          if (dataList[i].id === id) {
            return [dataList[i].id]
          } else {
            if (dataList[i].childAreaManage) {
              const res = this.findParentsId(dataList[i].childAreaManage, id)
              if (res) {
                return [...res, dataList[i].id]
              }
            }
          }
        }
      },
      // 当ids为数组时，寻找上级路径id
      findParenstsIds(dataList, ids) {
        if (!Array.isArray(ids) || ids.length === 0 || dataList.length === 0) {
          return []
        }

        const result = []

        for (const id of ids) {
          const path = this.findParentsId(dataList, id)
          if (path) {
            // 为每个ID创建一个独立的路径数组，用于级联选择器的多选回显
            result.push(path.reverse())
          }
        }

        return result
      }
    }
  }
</script>

<style lang="scss" scoped></style>
